import {
  PolicyContainer,
  PolicyTitle,
  PolicyText,
  PolicyList,
  PolicySectionTitle,
  PolicyHyphenList,
} from "styles/PolicyCommon";
import { useEffect } from "react";

const HealthTh = () => {
  useEffect(() => {
    document.documentElement.lang = "th";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <PolicyTitle>ความยินยอมในการเก็บรวบรวมและใช้ข้อมูลสุขภาพ</PolicyTitle>

      <PolicyText>
        เมื่อสร้างบัญชี
        คุณสามารเลือกได้ว่าจะยินยอมให้เก็บรวบรวมและใช้ข้อมูลสุขภาพหรือไม่
        ความยินยอมนี้เป็นทางเลือกและไม่ใช่ข้อกำหนดในการสร้างบัญชี pregnancy&baby
        อย่างไรก็ตาม หากคุณไม่ให้ความยินยอม
        คุณอาจไม่สามารถใช้ฟีเจอร์ที่จำเป็นต้องประมวลผลข้อมูลสุขภาพได้
      </PolicyText>

      <PolicySectionTitle>
        1. วัตถุประสงค์ในการเก็บรวบรวมและใช้ข้อมูล
      </PolicySectionTitle>
      <PolicyHyphenList>
        <li>
          เพื่อให้บริการฟีเจอร์บันทึกและจัดการข้อมูลเกี่ยวกับการเตรียมตัวตั้งครรภ์
          การรักษาภาวะมีบุตรยาก การตั้งครรภ์ และการดูแลเด็ก
        </li>
        <li>
          เพื่อให้บริการฟีเจอร์เฉพาะบุคคลที่คุณเลือก เช่น
          การคาดการณ์ประจำเดือนและวันตกไข่ การคำนวณอายุครรภ์
          การวิเคราะห์ผลการทดสอบ การวิเคราะห์การเจริญเติบโตของทารกในครรภ์
          และการวิเคราะห์การเจริญเติบโตและพัฒนาการของเด็ก
        </li>
        <li>
          เพื่อให้การแจ้งเตือนและข้อมูลเกี่ยวกับสุขภาพ การตั้งครรภ์
          และการดูแลเด็กตามการตั้งค่าของคุณ
        </li>
      </PolicyHyphenList>

      <PolicySectionTitle>2. ข้อมูลสุขภาพที่เก็บรวบรวม</PolicySectionTitle>
      <PolicyList>
        <li>
          <strong>[การเตรียมตัวตั้งครรภ์]</strong>
          <br />
          ระยะเวลาและรอบประจำเดือน วันที่มีประจำเดือนครั้งล่าสุด
          วันที่เริ่มและสิ้นสุดประจำเดือน วันตกไข่ วันเวลา
          รูปภาพและผลการทดสอบการตกไข่ วันเวลา รูปภาพและผลการทดสอบการตั้งครรภ์
          อุณหภูมิร่างกายพื้นฐาน อาการ บันทึกอาการปวดและเลือดออก
          บันทึกการมีเพศสัมพันธ์ การใช้ยา การฉีดวัคซีน การเข้ารับการตรวจรักษา
          และข้อมูลสุขภาพอื่น ๆ ที่คุณเลือกบันทึก
        </li>
        <li>
          <strong>[การรักษาภาวะมีบุตรยาก]</strong>
          <br />
          วิธีการรักษาภาวะมีบุตรยาก รอบการรักษา วันที่เริ่มและสิ้นสุดการรักษา
          บันทึกการใช้ยาและการฉีดยา ตารางการรักษา และรายละเอียดการรักษา
        </li>
        <li>
          <strong>[การตั้งครรภ์]</strong>
          <br />
          กำหนดคลอด อายุครรภ์ บันทึกการฝากครรภ์หรือการเข้ารับการตรวจ
          บันทึกการฉีดวัคซีน บันทึกน้ำหนัก ภาพอัลตราซาวด์ ค่าการวัดทารกในครรภ์
          (EFW/AC/FL/BPD/HC/CRL) ส่วนสูงและน้ำหนักก่อนตั้งครรภ์ และข้อมูลอื่น ๆ
          ที่เกี่ยวข้องกับการตั้งครรภ์ที่คุณเลือกบันทึก
        </li>
        <li>
          <strong>[การดูแลเด็ก]</strong>
          <br />
          วันเดือนปีเกิดของเด็ก ส่วนสูง น้ำหนัก และเส้นรอบศีรษะแรกเกิด
          ข้อมูลการเจริญเติบโต บันทึกและคะแนนการประเมินพัฒนาการ
          รูปภาพที่เกี่ยวข้องกับพัฒนาการ ข้อมูลการคลอดก่อนกำหนด
          บันทึกการตรวจสุขภาพ การฉีดวัคซีน อุณหภูมิร่างกาย การใช้ยา
          และข้อมูลการเจ็บป่วย
        </li>
      </PolicyList>

      <PolicySectionTitle>
        3. ระยะเวลาการเก็บรักษาและใช้ข้อมูล
      </PolicySectionTitle>
      <PolicyText>
        เมื่อคุณลบบันทึกที่จัดเก็บไว้
        ข้อมูลที่เกี่ยวข้องกับบันทึกนั้นจะถูกลบด้วย เมื่อคุณลบบัญชี
        ข้อมูลส่วนบุคคลที่สามารถระบุตัวคุณได้จะถูกลบ อย่างไรก็ตาม
        ข้อมูลบางส่วนที่เกิดขึ้นจากการใช้บริการอาจถูกเก็บรักษาไว้โดยไม่มีกำหนดเพื่อวัตถุประสงค์ในการวิจัย
        การวิเคราะห์ทางสถิติ และการปรับปรุงบริการ หลังจากได้รับการ
        ทำให้ไม่สามารถระบุตัวบุคคลได้อย่างถาวรและไม่สามารถย้อนกลับเพื่อระบุตัวคุณได้อีก
        ข้อมูลดังกล่าวไม่สามารถเชื่อมโยงกลับไปยังบัญชีหรือข้อมูลส่วนบุคคลของคุณได้
      </PolicyText>

      <PolicySectionTitle>สิทธิในการปฏิเสธความยินยอม</PolicySectionTitle>
      <PolicyText>
        ความยินยอมนี้เป็นทางเลือก คุณยังสามารถสร้างบัญชี pregnancy&baby
        และใช้ฟีเจอร์ที่ไม่จำเป็นต้องประมวลผลข้อมูลสุขภาพได้
        แม้ว่าจะไม่ให้ความยินยอม อย่างไรก็ตาม หากคุณไม่ให้ความยินยอม
        คุณอาจไม่สามารถใช้ฟีเจอร์ที่ต้องประมวลผลข้อมูลสุขภาพ เช่น
        การบันทึกข้อมูลเกี่ยวกับการเตรียมตัวตั้งครรภ์ การรักษาภาวะมีบุตรยาก
        การตั้งครรภ์ และการดูแลเด็กได้
      </PolicyText>
    </PolicyContainer>
  );
};

export default HealthTh;
